import { Component } from '@angular/core';
import { ProjectionsService } from 'src/app/core/services/projections.service';
import { RankingsService } from 'src/app/core/services/rankings.service';
import { Projection } from 'src/app/core/models/projection.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public rankings: Projection[];
  // options include overall, dst, k
  public rankingType: string = 'overall';
  public overall: any;
  public defence: any;
  public kickers: any;

  constructor(public projectionService: ProjectionsService, public rankingService: RankingsService) {

    this.projectionService.getProjections().subscribe(projections => {
      this.rankingService.getRankings().subscribe(rankings => {

        // by default, use the overall rankings
        this.rankings = this._useList(rankings, this.rankingType);

        // merge data together
        this.rankings = this._mergeData(projections, this.rankings);

        // sort data by rank
        this.rankings = this._orderResults(this.rankings);

        // position counters
        this.rankings = this._positionCount(this.rankings);

        console.log(this.rankings);
      });
    });
  }

  private _useList(rankingArr, type) {
    const rankList = rankingArr.find(list => list.position === type)
    return rankList.player_rankings;
  }

  private _mergeData(d1, d2) {
    return d1.map(d1_item => {
      d1_item = { ...d1_item, ...d2.find(d2_item => d2_item.player_id === d1_item.player_id ) }
      // rankers: 0 - overall
      if (d1_item.ranks) {
        d1_item.avg_rank = d1_item.ranks[0].rank;
      }
      return d1_item;
    });
  }

  private _orderResults(results: Projection[]): Projection[] {
    return _.orderBy(results, 'avg_rank', 'asc');
  }

  private _positionCount(results: Projection[]): Projection[] {
    const posCount = { "qb": 1, "wr": 1, "rb": 1, "te": 1, "k": 1 }

    return results.map(item => {
      if(posCount[item.position]) {
        item.pos_rank = posCount[item.position];
        posCount[item.position]++;
      }
      return item;
    });
  }
}
